import React, { Component, } from 'react'
import { Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Button, Alert, Progress, } from 'reactstrap'
import Papa from 'papaparse'
import queryString from 'query-string'
import { db } from '../../config/firebaseconfig'
import { Link, } from 'react-router-dom'

import convertToObjects from '../../helpers/users/convertToObjects'
import ErrorMessages from './ImportUsers/ErrorMessages'
import validateImportData from '../../helpers/users/validateImportData'
import timestamper from '../../helpers/timestamper'
import getRequest from '../../helpers/getRequest'

const uuid = require('uuid/v1')

/*
  <ImportUsersModal
    isOpen={this.props.modal === 'importStudents'}
    key='ImportStudentsModal'
    toggle={this.props.closeModal}
    school={this.props.schools[this.props.selection.school]}
    role='Students'
  />
*/

class ImportUsersModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      data: null,
      errors: null,
      isSaving: false,
      processedRecords: 0,
      totalRecords: 0,
      importErrors: null,
      isImporting: false,
      importComplete: false,
    }
  }

  handleUpload(e) {
    let file = e.target.files[0]
    Papa.parse(file, {
      complete: ((results) => this.processFile(results.data)),
      error: this.setState({errors: ["Could not read your file. Please make sure it's a comma-delimited csv and try again."]})
    })
  }

  processFile(data) {
    this.setState({importComplete: false, importErrors: null})
    const convertedData = convertToObjects(data, this.props.role)
    const errors = validateImportData(convertedData, this.props.role)
    if (errors.length > 0) {
      this.setState({errors,})
    } else {
      this.setState({
        errors: null,
        data: convertedData,
      })
    }
  }

  handleImportRowSuccess(processedRecords, totalRecords, row) {
    if (processedRecords >= totalRecords) {
      this.setState({
        isImporting: false,
        processedRecords,
        importComplete: true,
        data: null,
      })
    } else {
      this.setState({processedRecords, })
    }
  }

  handleImportRowError(processedRecords, totalRecords, row, err, importErrors) {
    if (processedRecords >= totalRecords) {
      this.setState({
        isImporting: false,
        processedRecords: 0,
        importErrors,
        importComplete: true,
        data: null,
      })
    } else {
      this.setState({processedRecords, importErrors, })
    }
  }

  //processedRecords, totalRecords, record.row, err

  // submitImport function using validated data
  submitImport() {
    const totalRecords = this.state.data.length
    let processedRecords = 0
    let importErrors = []
    this.setState({totalRecords, processedRecords, importErrors: null, isImporting: true,})
    
    const school = this.props.school
    this.state.data.forEach((record) => {
        const batch = db.batch()
        const id = uuid()
        const time = timestamper()

        let userCollection
        if (this.props.role === 'Students') {
          userCollection = 'students'
        } else if (this.props.role === 'Teachers') {
          userCollection = 'educators'
        }
        const userRef = db.collection(userCollection).doc(id)
        const schoolRef = db.collection('schools').doc(school.id)

        const fullName = `${record.firstName} ${record.lastName}`

        let validated = false
        if (record.sendInvite === 'no') {
          validated = true
        }

        let userData = {
          id,
          email: record.email,
          firstName: record.firstName,
          lastName: record.lastName,
          fullName,
          state: school.state,
          schoolDistrict: school.district,
          school: school.id,
          lastModified: time,
          created: time,
          validated,
          assessments: {},
          classes: {},
        }

        let schoolUpdateKey
        if (this.props.role === 'Students') {
          userData.role = 'Student'
          userData.username = record.username
          schoolUpdateKey = `students.${id}`
        } else if (this.props.role === 'Teachers') {
          userData.role = 'Teacher'
          userData.isTeacher = true
          schoolUpdateKey = `teachers.${id}`
        }
 
        const schoolData = {[schoolUpdateKey]: true}
        if (record.sendInvite === 'no') {
          const data = {
            id,
            password: record.password,
          }
          const query = queryString.stringify(data)
          let url
          if (this.props.role === 'Students') {
            url = `https://us-central1-bellwork-cg1.cloudfunctions.net/manualAddStudent?${query}`
          } else if (this.props.role === 'Teachers') {
            url = `https://us-central1-bellwork-cg1.cloudfunctions.net/manualAddEducator?${query}`
          }

          let dupQuery
          if (this.props.role !== 'Students') {
            dupQuery = queryString.stringify({
              email: record.email,
            })
          } else {
            let dupQ = {}
            if (record.email) {
              dupQ.email = record.email
            }
            if (record.username) {
              dupQ.username = record.username
            }
            dupQuery = queryString.stringify(dupQ)
          }
          let checkDupUrl = `https://us-central1-bellwork-cg1.cloudfunctions.net/checkEducatorsEmailDuplication?${dupQuery}`
          if (this.props.role === 'Students') {
            checkDupUrl = `https://us-central1-bellwork-cg1.cloudfunctions.net/checkStudentsEmailDuplication?${dupQuery}`
          }

          getRequest(checkDupUrl)
            .then((response) => {
              if (JSON.parse(response).error) {
                throw JSON.parse(response).error
              } else {
                return getRequest(url)
              }
            })
            .then(() => {
              batch.set(userRef, userData)
              batch.update(schoolRef, schoolData)
              return batch.commit()
            })
            .then(() => {
              processedRecords++
              this.handleImportRowSuccess(processedRecords, totalRecords, record.row)
            })
            .catch((err) => {
              processedRecords++
              importErrors.push(`Import error on row ${record.row}: ${err}`)
              this.handleImportRowError(processedRecords, totalRecords, record.row, err, importErrors)  
            })
        } else if (record.sendInvite === 'yes') {
          batch.set(userRef, userData)
          batch.update(schoolRef, schoolData)
          const inviteId = uuid()
          const inviteRef = db.collection('userInvites').doc(inviteId)
          batch.set(inviteRef, {
            id: inviteId,
            userId: id,
            createdDate: time,
            expirationDate: (time + 259200000), // 3 days
            firstName: record.firstName,
            lastName: record.lastName,
            email: record.email,
          })

          let dupQuery
          if (this.props.role !== 'Students') {
            dupQuery = queryString.stringify({
              email: record.email,
            })
          } else {
            let dupQ = {}
            if (record.email) {
              dupQ.email = record.email
            }
            if (record.username) {
              dupQ.username = record.username
            }
            dupQuery = queryString.stringify(dupQ)
          }
          let checkDupUrl = `https://us-central1-bellwork-cg1.cloudfunctions.net/checkEducatorsEmailDuplication?${dupQuery}`
          if (this.props.role === 'Students') {
            checkDupUrl = `https://us-central1-bellwork-cg1.cloudfunctions.net/checkStudentsEmailDuplication?${dupQuery}`
          }

          getRequest(checkDupUrl)
            .then((response) => {
              if (JSON.parse(response).error) {
                throw JSON.parse(response).error
              } else {
                return batch.commit()
              }
            })
            .then(() => {
              processedRecords++
              this.handleImportRowSuccess(processedRecords, totalRecords, record.row)
            })
            .catch((err) => {
              processedRecords++
              importErrors.push(`Import error on row ${record.row}: ${err}`)
              this.handleImportRowError(processedRecords, totalRecords, record.row, err, importErrors)  
            })
        }
    })
  }


  render() {

    let instructions = null
    if (this.props.role === 'Students') {
      instructions = (
        <p>
          {`Upload a csv file in `}
          <a href='https://www.dropbox.com/s/qmlv1vjdmfsn6if/sample.csv?dl=1'>this format</a>
          {`. Each row must have 
            either an email or username. If a password is 
            not specified in a row, then an email is required and 
            the column sendInvite must be marked "yes". The only
            acceptable inputs for the sendInvite column are "yes" or "no".`
          }
        </p>  
      )
    } else if (this.props.role === 'Teachers') {
      instructions = (
        <p>
          {`Upload a csv file in `}
          <a href='https://www.dropbox.com/s/nrizg9klv14i3dv/teacher1.csv?dl=1'>this format</a>
          {`. For each row, all
            columns are required except Password. sendInvite must
            either be marked "yes" or "no". If sendInvite is "no", 
            Password must be completed.`
          }
      </p>  
      )
    }

    let errorMessages = null
    if (this.state.errors) {
      errorMessages = <ErrorMessages errors={this.state.errors}/>
    }


    let progressMonitor = null
    if (this.state.isImporting) {
      progressMonitor = (
        <Alert color='secondary'>
          <p>{`Processed ${this.state.processedRecords} out of ${this.state.totalRecords}.`}</p>
          <Progress animated color='info' value={this.state.processedRecords / this.state.totalRecords * 100} />
        </Alert>
      )
    }

    let importErrors = null
    if (this.state.importErrors) {
      let errorsListItems = []
      this.state.importErrors.forEach((error) => {
        errorsListItems[errorsListItems.length] = <li key={uuid()}>{error}</li>
      })
      importErrors = (
        <Alert color='danger'>
          <p>The following rows had errors. All other rows successfully imported. You may now import another file.</p>
          <ul>{errorsListItems}</ul>  
        </Alert>
      )
    }

    let successMessage = null
    if (this.state.importComplete && !this.state.importErrors) {
      successMessage = <Alert color='success'>Import complete! Successfully imported {this.state.processedRecords} records.</Alert>
    } else if (this.state.importComplete && this.state.importErrors) {
      const errorsCount = this.state.importErrors.length
      const successCount = this.state.processedRecords - errorsCount
      if (this.state.processedRecords > errorsCount) {
        successMessage = (
          <Alert color='warning'>
            Import complete. Successfully imported {successCount} records. {errorsCount} records 
            were not imported due to errors.
          </Alert>
        )
      } else {
        successMessage = (
          <Alert color='danger'>
            Import has ended. No records were imported due to errors.
          </Alert>
        )
      }
    }

    let submitButton = null
    if (this.state.data) {
      submitButton = (
        <div>
          <Button 
            className='mr-2 mb-1' 
            color='primary'
            onClick={() => this.submitImport()}  
          >{this.state.isImporting ? <i className="fa fa-spinner fa-lg fa-spin"></i> : 'Import'}</Button>
          <Alert color='warning'>Please note that it may take some time to process this request.</Alert>
          {progressMonitor}
          {importErrors}
        </div>
      )
    }




    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} className={'modal-primary'}>
        <ModalHeader toggle={this.props.toggle}>
          {`Import ${this.props.role} to ${this.props.school.name}`}
        </ModalHeader>
        <ModalBody>
          {instructions}
          <Form>
            <FormGroup>
              <Label htmlFor='upload'>Upload Comma-Delimited CSV (Other File Types Not Accepted)</Label>
              <Input 
                type='file'
                accept='.csv'
                onChange={(e) => this.handleUpload(e)}
              />
            </FormGroup>
          </Form>
          {errorMessages}
          {submitButton}
          {successMessage}
        </ModalBody>
      </Modal>
    )
  }
}

export default ImportUsersModal


// WEBPACK FOOTER //
// ./src/components/Users/ImportUsersModal.js